// Initial heights only; users can resize every tool sheet from 20 to 90vh.
export const sheetHeights = { compact: '50vh', standard: '60vh', editor: '75vh' };
